import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PersistConfig } from 'redux-persist'
import { storage } from '../core'
import { CURRENCIES, Currencies } from '@/utils'

export type AppDomain = 'fanatics' | 'bookseats'

export interface AppState {
  currency: {
    value: Currencies
    isFetched: boolean
  }
  domain: AppDomain
}

export const APP_STATE_NAME = 'app'

const initialState: AppState = {
  currency: {
    value: CURRENCIES.USD,
    isFetched: false,
  },
  domain: 'bookseats',
}

export const appSlice = createSlice({
  name: APP_STATE_NAME,
  initialState,
  reducers: {
    setAppCurrency: (state, action: PayloadAction<AppState['currency']>) => {
      state.currency = action.payload
    },
    setAppDomain: (state, action: PayloadAction<AppDomain>) => {
      state.domain = action.payload
    },
  },
})

export const appSliceConfig: PersistConfig<AppState> = {
  storage,
  key: APP_STATE_NAME,
  whitelist: ['currency'],
}

export const { setAppCurrency, setAppDomain } = appSlice.actions

export default appSlice.reducer
